export const resolveTestMode = (testMode) => {
    if (typeof testMode === 'boolean') {
        return {
            noAnimation: testMode,
            datePlaceholders: testMode,
            followMember: testMode,
            skipCaptcha: testMode,
        };
    }
    return {
        noAnimation: testMode?.noAnimation ?? false,
        datePlaceholders: testMode?.datePlaceholders ?? false,
        followMember: testMode?.followMember ?? false,
        skipCaptcha: testMode?.skipCaptcha ?? false,
        crashIn: testMode?.crashIn ?? undefined,
    };
};
//# sourceMappingURL=resolve-test-mode.js.map